export default __webpack_public_path__ + "static/media/3_slide.f69b1678.png";